import { Schemas } from "../../../../features/Schemas";
import { SchemasPage } from "../../../../pages/SchemasPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const schemasPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.schemas.root,
  element: <SchemasPage />,
  name: "Схемы",
  children: appRouterPaths.schemas.item
    ? [
        {
          path: appRouterPaths.schemas.item,
          element: <Schemas />,
          name: "Схема",
        },
      ]
    : undefined,
};
